var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-card",
        [
          _c("FormIncident", { attrs: { id: _vm.id } }),
          _c("div", { staticClass: "mt-1 mb-2" }, [
            _c(
              "div",
              { staticClass: "flex justify-end" },
              [
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: "incident_form.handling",
                        expression: "`incident_form.handling`"
                      },
                      {
                        name: "ripple",
                        rawName: "v-ripple.400",
                        value: "rgba(255, 255, 255, 0.15)",
                        expression: "'rgba(255, 255, 255, 0.15)'",
                        modifiers: { "400": true }
                      }
                    ],
                    staticClass: "mt-1 mr-1 float-right",
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.handlingForm()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("handling_form")) + " ")]
                ),
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "ripple",
                        rawName: "v-ripple.400",
                        value: "rgba(255, 255, 255, 0.15)",
                        expression: "'rgba(255, 255, 255, 0.15)'",
                        modifiers: { "400": true }
                      }
                    ],
                    staticClass: "mt-1 mr-1 float-right",
                    attrs: { variant: "outline-secondary" },
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/incident-form")
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }